module.exports = __webpack_public_path__ + "static/media/laugh.9d6ce209.svg";